export const ROLE_MAP = {
  READ_ONLY_USER: 'Read only',
  ENTERPRISE_LICENSE_ADMIN: 'License administrator',
  USER: 'User',
  TENANT_ADMIN: 'Administrator',
  PENDING: 'Pending'
}

export const ROLE_COLOR_MAP = {
  USER: 'codeBlueBright',
  ENTERPRISE_LICENSE_ADMIN: 'accent',
  READ_ONLY_USER: 'cloudUIPrimaryDark',
  TENANT_ADMIN: 'cloudUIPrimaryBlue',
  PENDING: 'accentOrange'
}
